import React, { forwardRef, memo } from 'react'

const FileIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="36.4"
      height="36.4"
      viewBox="0 0 52 52"
      fill="none"
      stroke="#78BE20"
      strokeWidth={3.227}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="M40.625 45.5h-29.25a1.75 1.75 0 0 1-1.75-1.625V8.125c0-.431.171-.844.476-1.149.305-.304.718-.476 1.149-.476h19.5L42.25 17.875v26a1.75 1.75 0 0 1-1.625 1.75Z" />
      <path d="M30.875 6.5v11.375H42.25" />
      <path d="M19.5 27.625H32.5" />
      <path d="M19.5 34.125H32.5" />
    </svg>
  )
)

FileIcon.displayName = 'FileIcon'
export default memo(FileIcon)
